/** Available bot strategy types */
export enum BotStrategy {
  GRID = "grid",
  DELTA_NEUTRAL = "delta-neutral",
}

/** Delay between 2-hop swap legs to allow HL balance settlement */
export const SWAP_SETTLEMENT_DELAY_MS = 1500;

/** Slippage buffer applied to leg 2 of a 2-hop swap to avoid "insufficient balance" */
export const TWO_HOP_SLIPPAGE_FACTOR = "0.995"; // 0.5%
